import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { IPBlocklistingBanner } from './main.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const IPBlocklistingBannerComp = lazyAfterPaint<typeof IPBlocklistingBanner>(
	() =>
		import(/* webpackChunkName: "async-ip-block-listing-banner" */ './main').then(
			(m) => m.IPBlocklistingBanner,
		),
	{ ssr: false },
);

export const IPBlocklistingBannerAsync = () => (
	<Placeholder name="async-ip-block-listing-banner" fallback={null}>
		<IPBlocklistingBannerComp />
	</Placeholder>
);
